import React from 'react';
import { IMapLessonItemStates } from 'types';
import Checkmarks from 'components/common/maps/checkmarks';

const Science: React.FC<IMapLessonItemStates> = ({
  active,
  visited,
  process,
}: IMapLessonItemStates) => {
  return (
    <g
      className={
        active
          ? 'prefix__component-item animationComponent'
          : 'prefix__component-item'
      }
    >
      {active && (
        <g
          className={
            active
              ? 'prefix__active-process animation'
              : 'prefix__active-process'
          }
        >
          <image
            width={271}
            height={213}
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAADWCAYAAAAZzN0IAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJlVJREFUeNrsXcmSG0eSjUhstbK4 tlrSdI9MZjr1kTaHvvEn5iv7J3ibky5jppPM2tjTWkmRxdoLW8a4hz9HBkAUWcWtgMR7plACKKCI yox4+dzDlxAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAI giAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIorWIPAVEm5HS 4jx/gvEUY/7tkSuCBEKQKEJ4LONP8vy1HAfRfnYi44GML+Tp7zJeyqf29ZMyToI9fiTHf8rxexIL CYTYHOL4m4wtEIWOXRl7VQhTOVaVjVpGqPJ/oQ72v0pGV0aSMUr2Gy9knMm4J6NK9vpJSSokFBII sf7E8UTm71DGhTDCXRndTggdGVFGktGTUcmo9bWujVTZiLWNNJGjjmkIY3leK4lM7Xl/aiSj5DKU 8bI2tXIp44dEMiGBEGtNHEGIYVuJQoih05Ofyqj6Mq1lBD3qc/lZ6NnzfOyGRoIIcYSxfG6MxxMj Dz1WY/tZxKjltSl+fibjtXy+s/FkQgIh1sxU+UbGlyAOJYiuEENvSx5vy7tkVDt4vKXODyMUJY80 sOeZRJxAlCSGMkYgiwnIRB/L6/FSnssIMuqhvVbLe0d4r46LZWSyMURCAiHWhDweq49DFv4AaqNS clDC2JXn+zKVZSQc456RSVBiceLwsahAhBTSqFEbCeShpBHOZVzIa3o8w1GfX4BgZEzksxdQLzXI ZFvGQL7109YTCQmEWBPyuKeqo2vEMRWVEZQo7sjxnrx2Vx7LMcgx3LGfhR1TIW7OzNTHEhPGzRhV FFmNjAqiODPyCKfy/NSO8RSvndl7pqpUhvY7pjLGUCZh2nYiIYEQa0IePVn8fSGEpOpCSeO+/PCh PH4k0/iBPL4PElECEVUStgvScOLomt8kz/tkCzxMG//H7PEIyuTCiCQ6gZzIY93vPQ6273tipJLH mb23klELoQxH5kdRn8lxa4mky2lKrPYNLpstPTNX1EQJQhbVn+T4ZxlfylvkcVQiuQ/y2AN5lE7T DlQHRpLfGxNUiBNJjTFtlEk2ZYZGDAFmzIw4jkEkIJN4BHKRUckYwNyZyucH8ruG8nu/mab0rFU+ EioQYoXVxzey2L8VEtjdNnJQosik8R820lfBosJAHnEXqsPJo7Lt3FjEh8zN+TQ/9F+NS4jEFYn7 RZKbMQWZRI1Yk5EO7RiOjFxUmYzlM5OhmTe6g/NKfv+PrSASKhBiRcnjb7L4H8ni3+nbzkp918gi /kWZRcZfjExUkWTlsVOYLK44YkEeV90wU3E/XSCUGZGUps3IdmdmquS0MWsyeeh4Ka/JCK+MWHpC Jr1TM4m6Q/O1aIzJVp3S92tNIiQQYkWVsUaR7ggZdLbMWdpRM+VLI474VzmqCtG48wOQR2/BxxGv qbLjFYRSHl2VbIFMxg2Z6DZvBJEoicRDI47wB8aLhkxUqXRFkewJkfTls+O1N2tIIMQKqo/vZClt VxbnkdQsuQtfh5osX0N5/Mlezw7T/gJxxA8jr7ljgppJWC81/j2QSXQyuYSz9b6povTAjtmx+xxb zEIkHSGYLVEsvTMza76Vz38tiuRyLdUICYRYQfXxtYwdDT3XRboHB6kSyJ/h83gI5eHk0f0IxHEd QnkbmaiTt9xevjs/4kGYOXkjTJtKVEsl6mUwNCL6m5DID/U6kQgJhFhBTCJyWga2IDXWI5PGQ9zh 3Wz51ORxEzLpWsyJxp5oEFt26O41hJLu2PfORPLcTJvKfSRCJPuiYLojde+sk0lDAiFWDJqGP6gw NwdGFHN39Duh2abtfEbyeBeZIDcnlrk3UCYzIjkwElEy0WjZ0vHbO7aM4W9H62TSkECIFcO3ml0b cXfvYRH63XwXz508qrAaoQhxgUgqfD/N/u3DFNspiGQfymoXIfcDe191JC+dCeeISTMUk+bxdNVJ hARCrCCysEAMh9/NY5kM5+Sxgv6bRSKJIJL8/Z1IdjGQ+DfL2ekhbuXUPq4cs9okQgK5Bt6sdmUv f+6LesX3uJXv8un+vhdqqXj8hpOI3sm7WIwleazqXx1LJmzUSCa/AXJ03LzZbkgkq5Wu+X968rnp hZDIaJVJhARy5eJ8DDntk/pk4fLtp6RpGBmftgTem1W3Louf6jy8lO/SijRylB3UamLdOB9BGhd9 HXH1/5aM6k2zJhNiz1RHdro6ocAprKSpf7+KEg2AXV0S6ZIwnCz25XFfRi3jMNrzU0zkHG4QUQbP zfNkC3mCupqPiwjGj7Ogm++ocRH35R890KpbyOfQuagxTVqST6tnPZLjybpHNuJc6rmNCC0vI0Pz a2tIinNmTWzMs+TO1r6pjzIYTq9iDx8ZJ9uIWj0S6W4maZSEMdItQ416rOzCBpTGU7msXvGIu18n zivniAmtNTO1/sPW1DIvpzhuyWv7sqAfyc//ceOL3mSiXso/ui/f5S7qYOis0jJ9+l27KIqjaeT7 MrYn6+B4u3KlRf27VdVdhiasPIIgA87rLAEurSGRFGZN/mvdPwITzc2z/DMQag9zTJ9vlQmAJJDP SxpPcLzAnXwAwujBrp6VvutZ9mftzroOsjcLCV3eHasp6kiMrTBNhfHF2OptvtBw5fq6e/vzJfvu yL89le9V960OxsxeHuA7TSyUWhO26gt7vHqT7OaYYNGU5zZHe3rKfUkicc1IJM4rEc8QjlXzevI5 BuLU86B1WQcyvhnrXFqVG0S3/cTxHSIb78kFmsiC3OsY2097dkfPtTRR8k4XaYRNWhVe8VAoEZfa niOhd8cKocy5AM25RRdGFJrZESP2u8m79vbnS/YN5d8cdOy7deW71DvyO/csHiJX3NrGZNN/V9PH D2W8ln8vWd2J1ZpkN4P6k+4mU3SVp9Rf4PxeNkSSs2arsJ4Z5bH47ouPQzG3Js3Qm9FOvhnpBs6q RKx220kcZbXuO5WFRU8QKeil7SIcVxUiB7NHfAePdxqnVuxdcYGT+R8S6moqcUSvF3GMFG953D0V Hjq35Kk39/bf9HPsOnHId+widqC6YzkVUYvmeP5HBGG9Mmdc/o21mU5/WalJdjOoM/rvclb2pkYW s6pgel5RtCeTyAAKMa0xibhJE2zOzd2cVH15GQEMJVQl1r20KmZct53EMUTR3TtaAs8dVU4Su1ZH M2IvPmE/3vfn9Xn09/bnnVpv/IsusYdhVvYu14E4xMJGFqa+pnv7OldmzrDQOHDdz6HfdzDAv6/E cWAfqB9YLYw87iHnImBhPbfvmIp2BAdCIHeGas6spz9EibnSKugjO6/xGOfwCOdYo1G3QlOecF2x jETg9/Ebk5dWzEeUAtidmcW3fW277SIOlf1bHfNfDPqFuthFoV3kJfjQ8nizkOIdkImTR1FD0+3T tOBETV5XEzU0dXJXIJD0IjR1KvrmqHWrQwOE/l6bA7cP1dGX93T9u+rnkNWpKevVIyvdl7M87+L7 1VhMO+h1gjTzjnyf7tTMmdWOIbjqkspp050sNWFkwXS07ugR0uQPoezuNud1FmvRFhLZDrMsXyWM WSW0U1O5Wk+kHmsZgBD+KzvoSSAf5ONY9Bl04GysPDNyHwv5ABOvzIxE8V1vCRC3GhOnLMCbFgKX kl80rxOBu0W+U5xYglRWCvuYECChiJ0c3f3ZnpojdFyYK9U+PvfA0tc1AzXp8aGRR95P3ocpVqPI bw/28ggDdTgnuDmvF4nYToxK9F/lb9iW7z64sBKBXvFLlYg6jTPJukM1tohE+rgpTNBW4sxM4uAl E+V5VxPv5Dqfigq53dif7vqSh1as2lviM8imCQgjL7h7GMvSqqE4khOGmyyLdTTj1XfLkkR0AacD G+7szPv7+B26s5DXfifMVrg6SbMKOoCPQ5XGFxhOHp6BilyQ5KnkA3w3r0sxabY6u3CoDsP6KZF/ BIur6U/MEa1p71l5wBRM7geZhrXebXobicQdm0f5xvHaTOL0yh6rX62S8/J8EpoYExLIzVSHlrvb 0izGRZ/BXVtws4Iu962Kd16gXnS3rNqNAJ6E2I850nhXgZrSmTXAQkZYsv/uiG3g2fs1pqRvNm4O z95D0RklioI8IkyWTH5QSjNlFM18ii57veQefCBZkeCtIawhiaBJ0/7UzpM2ddJq59GrpA+bv7c1 BOIkUhUksosbx30bqqC97mvdNVNmFt1IArmZ6tju22KNe/M+g7wI4XCcyf6DwtdREkcZvLO403Ld knhl6Tv/faWKwc8SYheyengNxTKAGnoEtfFF8/1DWWXc+5sUTsPo0r0uCgEX8R++ObF+JGJmzA+I 7u3WTbRtKuJAYh3aizITGaZ4WQJAVa2GJOwgKPJ7EsjNVIeaK9nH4cTxsJH+7jNQ5THzGewWqmCx dmZ1Q8K4Snq6lFzc9i3MnPzWgdmzWS0MTGEkEEhuT/AAd509222JHuJ8Va3P7Xk1lJZ8vfUiEdws kE6gofsVslrjomnZRizmzSCL13cG1dz2IEf1pWm+1vc0Ya6eSGVLwx3srGRJfwCi8Dt3We4Od++E HiFxsbFy9QGEcRNnWBFspgokB6UpmZ3iDroFf8mDRi3FosJ4LL/zMlOqs/wrrD2JIAcpIJ0/FgvI F1EsbwJtJJHFLN5iDiuZ5tSKW//bu6tPHtqVbOC9UAvVke/afy4GyCPCZ5DKRdgJH6/o7nuSSEYP 5HeB1wsHan7dmyItkt0yoovtJZEnwba9u6jKHgrHeCobR7WVQEoSqRrfXE7A8908hBW8sG42kQSy hDz20YF95uuAszGpk1Erc39p5JFVSCH93/AZfA7ieBuJ7OIS92HLjvDzfmPnJiyK2LsB2bWOROza a0zPgdbEKB2J9wpneFmJvQpskEYFspw8KpkkPVlYHfd1fGGkkcv7fwXl8QgT645tfc1VrfrcxLHM lu0WjrE+fBtTfKWy4tZCQ6Rrf+eWkcgTBARqBHGOzUED7YD+t3MFldusQIp8q1kW8hRRqskCBVOe /owDWWq26IJS8uhiLzw3FUJLw9wb5M/wd9yFGVAUZLnxIvwcJIJjLDNlY3ijb+t7+WVaQSKN+tBo Yg0IzKrzrl3/6L6tfRBLL7TXkVrkw8y11yxifepkgwpkYWZ7M+XoyuOBqY3cjew/5eT9B8yWh8Xd yPMiVrHcXZltWS2s5kWF9DEaIq0xiTxBVHHeZdhGFPG9+S357AMZhM/bzuFzk0fZmxc9eRPiYCKS 6mr5+ShZ9jIJxJspR9ttqXD3yc7SL4084jfy+K8gk4dhLs9kpVTH2xxi6S0L/2P7XtaKRBr1oUmQ A/TDnQVRlQF12wsZ0m2Ep0egmXdOj9Bw9lN7rj40zXc6T7cZA7IyBLK8mXJ2mH5hZktWHn8102XW D3V7wZEWwvrUyfwc/8a6kYiXX+gWW/UwXzZSfSDDWxMJc5NuDWV/jTygoWUrV7ceTNddnYWlEaYa JJYnzx34N740n0c2W74CeXgm5rLgKmINSaTph6u1W2bOUzdfioDA1qqPwmGazZZLI48csYwG3UmP h6ZCtKeuksydW68JcusE0pguu2hlmFPs72Or1pspL/o8SB7tIpGiH65vey/buo39ll33NE8eyX0e J0YW8bmM3+SxjueNAplocSotpM16ICH8t5yCF1qbtGf1MCIiTJU00lcFeXhLQ5JH60jkif5bFZIL t4vgujKPaWvh2reIOPLOihcQOrXSBel3efyzjJ/k8a+mQKZHVvt2LO99Jp97utm7MKY+TqE+PPsw +z7KrNQHCPde3PsnebSARBrnab9jOU6dnSb2w+N7ZpnIbfB9lCUgJiAPNVkuGvLIZouSxr/lKCOJ Apm+knFqF+VM1Mdq1Lzt3v7kPpbxJ926g/mS4zoeFhW4SB4tIJGru+ppNulOx8yTnO+yb8QRUccl lsqzagl5eGyHVxw7xS6L+jhemrmiBBJ+saGmTC0/nwjJTHIhobAiZQxWwISpK6ttkAsD74ZZPY9Y FtFh2PKtk4hWB/tbjYZZ18S7uvvpGtKSjl59vvLAMa/ngp2XWNY/jS0gDyeOE+yyOHG8MPWRnsPn 8cJeV9+H1r8dyjX4t6qPmm0dmrtPtNoGXVRhyqHeaF8wCxJrc9ThGpBIRBOuHVnxj6bm47sK+/jg yVu6+/nuo2aUanW2nCiJco4RhZWi5za1JWzdI0tRKFpJQckhOlngmAlDRn0IX4iok/rctm6PVsZ0 WREC+RYTLCD6sEJ1sbmqXl2qj9sgkYj/JXTuyxmhYqsP5A7aq5fzefZxav8dNO6qrujul5BJqhml 3S5MlHuWFBm9lOMD3Ei2W3ADcYepb9Eew8/xM4aaKr83W7VqrtRKMudW0nEkxP1KyON/V65h2AqY MLMmylfUPqDf43ZIJOFJLgaN6li5jYTXIl2yRnItscq6/A3QQHpZd79Zq9gKdT12zGzJ2dVfGYFk P4jvvqy787Q0Xy5gtugW7U9y/Jc8/wnqQxRHfYLSjUPrI1TLZ36Wz/64ks3Tb41AzKn2Ai6PiKbW yStPoSJTqkget0UiAdcjeF6SOjdPcAedFpXpyw9Fm1Peiyde0d1v1gsKBJJrt+hEQOSxVpWLbr6s u+9j5uyD0+cc/W108utOiyiQ+hdTH1owWh2lAZX1L6ZWGPvHla0e1+U6IoksJ5GsFDpW/SshLykU BPJGTdIy89i7//lxIVcpLjpZELoevVDUQzhT2rB1mxb8H2j9kRuOIcq0finEcWTKQ2M8zkEc/7Py BbBvjUCu7sQeUP4vrHMn9jaQSEQB6C1sperFOjNpnaX4wjVJBYHEfpirTL+su1+CAkkeA4Qt3HCn KOvYlrB17xo4LggEvV5yG9RTBIgJwZxMtcbpujQCWwEF0tpO7OtOIhHKwXOTTsH2RT+WuOD/mJWO dD9WWcdzobvfG6oFfYvjYtX8lsR+xFKBoNOchqVrmn7S0HSZ77/Wq2yurCCBbEQn9nUkkUVzZM+U RxoX1yNdQQb+uXIs6e43p0XLKuTdgojacs2L7oUzAjmzVpWpyKz9ce36GN8ygbytE3vuQHZuk1f7 YOgdbObJJz4tiSxUUcsqZFr4PtJbPl9WV7tOicZid2au+FIbnOdLsmx1Tuc5fm7P1azpyHntr6WZ vgImzBud2NFIOR0inBmRqKlqPPfcmfnEJFIuZjdJUuOreiuBxAUyuUm1tU/RamNV/B8jEMYZ+t1C feRexrVVF1s/X1/39k+ud2LX9oW9MyQTvURQTbmVF5b0AyGRfHoiSeHNUow3UTNhg69R6f8Y2y5L VtXnZsoogUzl5nkp7zlJ66itb5VA5juxD4ShKxBIpXvkHsruCRlTUyOZRPrh8/Z6oVnD8/sR/B+5 Kfi5+T5yj184pKf1bZcmXGMT5h9CIH+vTcpFD7J5bna3RkDmG59vf92FT2QbMQZlf1tOcmLV/R8X bfJ/rASBmArRoJmJeqLVI30qJ/UlYhCcPJC5WDbLDmWyXZ8kQtD/sZEKRKGVlb6TE/m1nNDuue24 5F0/Tz5S8lDfyMNmaLp3drKmMN9LlCDo/9gkAjEVoslC23Kyd4eIU6otNiTLPi+28gpOVlRm0vd4 3gwzdgn6PzZUgThj/y/sxfvyuC8ntzuygLKOEEaF0N90jAY7NUgD+RasWEbQ/7GxBGIqxEnkOzl+ XVv3LY1+7F2aaVN5LkYNH4mGPWuU5G6YOV2pQgj6PzZRgXiMaTJz5msZZ0iqO9C6CCM76ZUrD+9c dg9l8LzpUCcwb4ag/2PzCGSeSJ4mUyRPZOzLhTiqLRJSq1xl5fGy8ImctKh6FUH/Bwnk4xPJNxNr QLWvF8B3ZbSmwqE5WfOOzF5oR/1Mgv6PtcBa3KmNSJ7JyX6tHclHkINOIro7o8Fnnm4+CU0JAIK4 Rf9HWPB/6LzVlI3QCv/H2hBIc1G2a9QMGVq2bkRJ/ORbuygHRwIhVsn/ERb8Hxo0eb72/o+1IhA7 0Rqx2ptaAZb6olAhr217N1+ksmIWSYRYIf9HbJX/Y90UiPpDlDNqq1Q9vbBScNl8eW3H5GbMOMyq ZhHEbfs/Qiv9H2tIIHpxfpZxOjEVki8MolS1hkg2acrWA1QhBP0fJJDSjNEYkWNVIW5fnsAP8gpK 5GTBF0IQ9H+QQMqLpM7UsVyIuki0i0ogr0yR5F2aEc0Ygv4PEsgSFaLOVG26o82GtW9odqCCQHIj Ym7pEvR/kECuwlNv1DO23qGpjAk5BKFwS5eg/4ME8jYVMphaEaIAFZJAIIFbugT9HySQt6qQ8PYt 3dy4pzRjCIL+DxJIyfhvbOmCQHKC3TGSl+hMJej/IIEsM2PKLd3s8zg1J2pifgxB/wcJ5DoXzfNj 1MYMzI8h6P8ggdxEhTA/hqD/gwTy3nga6EwlVsD/AfWxzP9RtdL/0RICuTI/hs5U4nOqD/d/ePEg +D/cgdo+/0crCITOVGI1/B8BdWqy6jg1JRxhPqs6HrbO/9EWBYKLSGcqcasEMjZTOe+8nGLOqQ8E BZRfts7/0RoCoTOVuGX/x8TMl+i+j5OGQHQ+ptaazi2qXv400JlK3JL6mM6bL5lAzmy+qVl9Jj+/ bOVNq2rXxaQzlfjsKLZvs8lyGpodGN3Slfk4kff80Dr/R6sI5JrOVL2wdKYSH9N8KbdvXYGcNfEf ar50WzvPqvZd1KXOVCWRI0hLr5lKAiE+hvpYsn1b5r/EOrTY59YqAlnuTJ3VCnECoRlDfEz/x0Zu 37ZVgYTGmTrxkofwikd3pF5Yw24WXSY+CoFs5PZtiwnEnaknhbQMfnHP8JwKhPgY/o+N3b5tLYE0 zlTNjOxMkMh0iXFhd4Z816ACIT5UfWzs9m2bFQiwH+wi1+4l9zFB2jXJg/gQbPT27QYQyBvaJM3f QAjig8yXjd6+3QACUTU5rfA3dpuROnKBO27sEMR7qo+N3r5tOYE8ljGQv60Wokg9GX19wUbsg0z0 b48YBHFT/8fC9q0rkHojtm8d3dZd3cz3+3LZdoQgqo6RR9ySF3dkbMvQx0IqobNZJhzxkc0XOOdT sfuSNmb7ts0KRMijLyNWRhSVqo4dI5C0AyXiBEL1QXyI+aKEcWLDS0bUG7F921oFgmsczdehRJHV hyiPtAsFMqAJQ3yg+YLgsYit21wuAkGKI/nZsPXbty0nkEmEo7QPk0WUR9xeQiAE8Z7mSw5XB3kk N2Euren769Zv37bYhFEHaq8yEyX2QCDbMGH08aITlSBuYr5g6zabLCgXoUf1fyQUrOpsTJxAqxRI 40BV7p92jCziAOpjyx6TPIj3ViCF7yOrD82vOgqzXsyaY1VvjPnSRhMGPg1VILGL7dst+EEW1Ucg iRA39H341q1Xu0PN3QgH6nS8SeZLS02YTAowX6q+qY9Ubt9SgRDvSyALhaqUQGZZ3kOrQ7O9UXVm WkggJ0IMEyiQ7DDdggkzgALpBO6+EDcjjxTmAseS+z5emymT686MrA7NIG1SjHPLTJjH8IFUiEDN /o9BQR7dwAAy4v18H573slCsW59rEe+A3rdPN+rktGwhfSvksa0Egl2YbLI4edB8IT5AfeQdljMz WeKhmS/ZeXpm6kOLef+8cRneLYwD6WIXRgkkJ84ViXRz5EESIa5DHlAfOe7jGAW6X4JATiz7Vmt/ aDHvH9OmpWi2RoHYFu4LCI+OqhBXIh4TUgVGnxI3Q+k4PQF5/CHT56W1CtEQ9hrBY9sbWaS7TSZM NAfqWGNANJQ9NmQRSRrETdUHtm1nPYaUMJQ8XhiJZB+IvD6Sn19snPO0xSZM7by4QByJZgtxUwIp TBc1W9JzOT7H4yPhF1EmYxTofrqRVaqqdhJIKkmDIN7H94FtW91lSa9kqPL4HSQizzX2YzzcZPXR UgVCEB9MHr5tq+rjCCbL7xiiPurjMIs8/VXe+2xj71QkEIJ4Q8JqTktu1XBsDtOZ+nhhjtTpmQiU oVVdf5Y2uTgmCYQgGvUBx2n0fJfDhjzyFt8rS90fXVjcx6uNb49atfNP8grs9JkSNzZdRqiy/tpM l/i7jUwgR6Y+dOdFG5f9mDa9NHe3pQTiJFJEBupriV5V4ioCgd9Dq4pptGl6CeXxG8wXUR/1iZku Y3nvFpuzt4xA5GLua2PtZOSRCgJJab4vDEEsM10S/B7ByeNXEMgftm07nXOcsjFIi0wYu5iPcCOZ yqSoddRhVgQ3+WN2pCOWkQeqjEXdotWt2l8wfjffR0TKPh2nLfeBTJIRiFbGjr4dN8EgiRBL/B7J K6y/xk7LLxhQH6pKNGT9UubSKU2X9hLIP+XCXrjycPIYYYwLEuEEIHmUJQrVdFG/xx9mtiRXH8+t cFAt5HIu73sm7/+hpvpoLYFoI58TqI9qjO24S0yQIUiEjbVJHmWwGJymAeQRf7bhpouaNeo4HU5o umyECXNPJkffU7AvTZrmitlOIq5CCJLH+bzyyMSh4zfswojpMpY5dCLvvaRyXYI2buPCMVZ78x+d JEXj4yxZpyARZulutPKYhamrufKT/PjfeOwxH/KeC5kvhxtVKHmTFYhMkFGyHRfdblPHV64i5e0H zwpThncUkgfIIypx/J+RSI75OLS5ckG/xyYRiF1k9YFoZ/RY1rA8xoQ5gUkzoi9k48nDd1uEONK/ TH3kXRcNGJM5U9PvsZk+EHWkHgmBVJPQdE/3KtoowZ9fpwrZePLIquNfdoy/mCIZy1wZyvuG9Hts JoHoBb8vF36CQrgRPTw0FDl71b0RkDtUqUI2gzw8v6Ukj2cgkF8s/mMs5HKJIkGH8rnvqT42jUDs gu8lS3Yae2LUEcijKIardyOqkBYTR9lJ7qwhj7zL8q/l5KHKo0aiHMljUxWI4B8ajVpbLEgmihMj jrxd9xKTiSqk/arDm2AfWiWx9BPJ4+OilfVA9OKnNEBA2VRIopJJVHk5fiWR+zLuyNgN893qQuC2 7roSRwizvKcA/9dcnIc6SH+C0/Tf5vMgeZBAroQWuf27TIgDuRN1yixLTZS6J+NggUDK88EptL4m y6hQHl7T4zczXVSBZBXym5EKyYMEcm0VEsUO7rgdfFfGvowdEEhpypWtLzmdVp84SpNlCJ/XMbrH vYDyQG5L1PR8hKj7bgvJgwTyThUykMnVP7ech47K2T15rOSxhXMQMRF3CkVSkUhWnjiWqI6c1+It GJQ8frWRq4r9YUFiGucxRkc5kgcJ5J0qZCiTpKcOU+0kJnefSogjac/cHvZt/A52ABIZhPlG3CSS 1fBxlIpjil20IdIV4CjPJIFKYjkw7DdrBpW38Y+RFzW0z5I8SCDXUiHfyET5Vn0h53YHSiCHTDFa N8TvYDrcuboNNeJEEpcQSeTCXvr4Rjx/TdJwxeGlB5FpneN8js0sid5+AWUIs78L1cQC2lBqWr5G mGqQGMmDBHItFaJ9O76WSbOLHZkEItCcmej1IM5MAusOTborr+8VaqS/oEjiwli2GGLLF365wOsl C/5dpBEXHsclhOHlKD350eu7wKeVVcdrI4+8u/Y8zCqo550XqA6t56Ep+VoQ6Jn3cSF5kEBuMtn1 jnMhJNKTu1DXfR7yvNI72TliRTRK9ZGM+zBnSjWyhEiUiOIimVQrrlA+ZOEv80W4KqjDfMW3dxFI tTDiwvfC74y+LevkcWFEn9xR6srjDxDHy4I4Tq2MgybFaSlCrSb2jIlxH/MGvTFaO0/px/L33pPF P+jJnBVCqERhRCGJdM+UR3go44G8JiNv9d4FieyBSLZAJL0lPpLOwjGuMIG878IvCcg/M1kY7/pd JXl0i1EVv9cJw4/wdcyU4jEyZhHbE500tHoY8p2UOMZUHSSQT0EiWzJZBzJpd0RRdIQUaiGH6o6R RTZf7jUEEqFEErZ94zI10l0yVs35+qELv/xTUDJhThl42Ug4OPU9cdlXiDhnHSPi1LdjRCxO8mJQ MFVyn5ZRUxwqmy1Ijswk4kmSx5Y4OYa5ouUcXHUwHZ8E8lFJRP/ub3TIpN3BJFYi6Qg5pD0jiwhC iRgJKiRv/7qDtW8O2diDKsFrrlAilEhalUv9ngt/6Vl008IX+iXKJICMrmqjkWKjPmIfZDwITTDf FL+vGDOH6QWaXXt9Fwz1ceRetfK+87Htuv1K1UEfyCdYRhErIDtW1SrRxLu+TPqtkflHqvPGvo67 MF12C/JA/IhuAztxpB4Ww9a8OknY6YmrRJ/XWPjpuibQpFjgPvB70rtMmC620gc4dz4Xi98ZCwUy +64XRhhKJtWF7awMR5b3pOpFyUO37lnHgwrks6mR72Tcl0m9LWNHJnIHd0ed4HmSb1nsiKqUVMaQ 9LAl3GvupNHvqN0V84Vcc+G/jT1i8Xvqumib4Qvd/RbpHT6QCAUC1RZ78wSSFtRRXbymZKLRo1ow Ss2UsfzsAupJieMpiYMEcptE8rU6WmXhTzqmIJQgVGF01PEKxVG7iVL4P3wxuJNVP1sVBJJu+zJ/ 6ML334UufzXSBHTh6mJO2pR6YiZSnd4e3lFFM++y+Yfz51vr0Rs9YVTy++uptZPU751TE2RMZLyW 927XJA4SyIoRyRMcL2RSH6jDtYI/Q8YIxKLkoQuhVzVEE0E2ofh5wrj1S/2BC3/2O/TPQ/OuKQhJ F3i3tqFlFMbv+C75FClJY1Q4V4rcURC/r8bQf0+doWdFfMhl0kLH9HGQQFacTB7LYV+OfRm1jEMZ uzK2o/k3+ribzi0GOXaijSnUx22SyMda+L6xpP2HsysFjbxO0JdY/9CTa36nfZzfk2jn9wDn52jh 9w2T7aY/T1ausrlEJI7bR5en4IolF11vf69kkubJVknli2jJni/im4tByaUCcSiB+A7pbWEWrwUH af0BCz8v/mR9iMOyhf0e0PP5COf3hERBBbJpKmVxMXyL15RgTlboHJcL/58fsvC5qAkSyO0QzO1+ JS58giAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAI giAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiA2C/8vwACvC/a0NQI3hAAA AABJRU5ErkJggg=="
            transform="translate(-18.548 35.906)"
            overflow="visible"
          />
          <image
            width={247}
            height={193}
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPgAAADCCAYAAABkMA/AAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFyNJREFUeNrsnQlX28gShUvGYGP2 rPPmLfP/f9abLZOQhUAwi438rDdV0VW5Jdtg4lbr3nP6QCCAQfpUS1dXiVAURVEURVEURVEURVEU RVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEU RVEURVEURVEURVEURVEUtR1l/BNQbdRsNlvl/p1lWUbAKapFEGdr3L+zmvc7Az8Bp2IGu2mtA/is YSUNPAGnYgW7p2vHrd4KoIfAzufrQVfulgc+GdgJOBUj2AXI/fnana89WLv68Z0A5CHrbcvAnrg1 XQJ962En4FQscPcU3mIN5ms4X/vzNdK1rx/bC1jyJsBzgPtuvm513em6XwL99wdFG0En4FQMcO8A 2AXIh/N1DOtovg4U9IFa8nUAnyjIBdjj+bqBtzcAvQd/qqviyrcJ9D5vM2rLBsYs91DBPp2vF/P1 UtfZfJ3o5w4UcHTTG58haomnCqwBfa1rrOs6sMYA/D2CPn8w5W2BnIBTMVjvPYW3gPntfP1jvn6a rzcKuwG+r/+3DxZ8GeC5wmkuOkJugH/TdenWlX7crLy588Xrb4U1J+DUNq23AT5QN/z1fP1zvv4z X/9S2M/0c/vOPe8tCTMtSZYHILdY/Abc9SuF+ut8XczXF10XAPw1gP7QBmtOwKltQ27u+bG65IX1 /reuN2q9R1Jm0XsrWm9vxXNw16dgje/AopsVN8A/uWWwj/XrorfmBJzapnpgwQ/VWr9Wy12sVy7u Du2BrwK43w/HPXFLwCHoZsk/z9e5riN9O9TPXYE1n6o1jw5yAk7F4KLvqQt+pBb7RC26xd0+5l6X olngbciyG+inas3PdJ1KNZt/rq/Z3PY7/fqH2CAn4FQsVnxXym0yjLdXzZgve5jg2xn8bIvT9+Dn jxTk0HbdoX4e9+TNmttDY0bAqc5KM+hoxbF6rQ9Q76zpjj8W+Mw9bPoK7zAAPAK+Cw8J8womMVlx Ak5t0z3fxIGSTQLfk2oNPJbLoneB1lvAzTeXX2LJrhNwimoGvSeLdfG7ADcm6ib679BpNQJOdcdL X2HFAnrmQO+DW/4gZQmsVb1ZLXsUWXUCDjFh17t//DB65n9niMNDGW1/jHPboO8A6Bm45YXF9qWv dwFLTsB/EMRN3UH8Tff9fYL/7JYc96SDBzxkewejvDW31z1VmAuwrQruSspqt0kMVrzfMZibkjkh 9zH/+9vNZgT92eC2MlLbg8YjnDFtOaE1t9r5Yr++KMaxophiFdVu3xTyqX7djIBvFuzQwuwovs3c kxktSuVsMEF/FsjNclttuJ3iwhNc27TgHvJeAPIXuk6lWnlnDyla8A1Z66ZWP5Yg2YW3uNfqbzi0 KHfoOsZYkpgI4GNYdw7wmNTT+6fYLiv2xIsCGKu8s7r5nRgeSv0EwK5r9ePb/Qzc+wOAHCuaLLbC Y4TX7qbbSEliQ+vfrjxAsCEDHuX0FlwiteK++8y+u68yuuhPA9tvX/iChJFUixOG8P5AqocYBKzJ jSZM7FSRj63kKZAHHk7iboQuxP2+pdIUPKfQnnJMwjp63CMP9YyjBX8i2HvwFB1JWU54JNXa4VHg SbvnAM+l7PxRJE6KI4If9P+HyhLXch9rmgv23PetbBV1KBzwf9NZpHB7yH04uNBKqrju27qG/ZbB XVcrfAhx0IkmO+xEkp0AQis+cE9cb8ELK11se3zUrx9KtSzRbsKV6o4d2Dvud9h13xuroqI8ofRM gPgcCcLSlt+lac0I+GpgGNgHAHUB9JlbBjg26xuAO4VVSaEY/JuUnUR23QPAEm6NLmSNxcZTU3ho QaRaOGHZ5OhOKG0YjNBJsn1Z7J5KpQR4oJ2u3QQGtkH9UqoN+gxuc8/90cN+gzuFWd0DB98UEkFY lhh0o2u8jlDX0EP9+Aw8h8/6dVGeUHqGa4vXFT2uVbqnxhReRFd624/8BvBPdwO72HMsCgxe63ol 5T4kxt0D5wZju59QAwG7GPg1mYJ8K2VLH6tYuvNWPOB19J3XcSxl19AX+u+hWulvGvfv6ddjI35p UzfPNZJUu1JuNVmzh0N4uO5ECndoYorvpf73L8tKtka4zeKdKhQF0G9gGdwnS8Cuq14LVbLh/3kA l/1CAfysSbixlCWJ3u201497pfY7vIEH04n+nwf9nkf6tblUyzbvRLPrCUFu1nsE+ZMj5z31Iobb Z/8nq4RunQU80Ep3HyxeAUXRSrdoyvcW4D7T/zOSalvdkAuerXjj9SAxMnIhAf68KwXPntqhOPsQ fodXUvYbe6OwH+lrnirg+xAS2LQNtAytjscD7vnQJUmPZLFYJIsM7tC0FNvD52GTNeC2Wt8C7KKd 7r8A8JdS7Zc9cGD31oA6BLmAe+37hR2Bp3ALFxEtkrnjZwD3G33tr/X1W2njjgJt79sxxDt3w+QJ xOOhXmyHUm2JNHTxd4xw23aqhW3WiHEsZVtlWvAGt/xEQfhZwbZe2T8pHJYhHwRibNnAjVF3I9pN aG7kLfw/s0Yn4I6/dLkCjL3te/QUcEzo4Tide3D9UojHs0ByLWS9exGB7eG+hoToRynbKn+Tapkt AQeXbRfc8lcKdwH2L/J3n+yfAe6RVAtVNgV23etCy2yAH6h1tb31Iykz+x5qs9iYK7DXn+mNY4m1 iXP7cKpGa+PxwCwyTDwa4PuRuefeJb9XK11Y7KK76l/z9U7+Loj6AoDTRXcX3dzhQ7VwP6nF/kUh /1mBOam5CbJnfPiYFTfIzaU8BTfyQF/3a5cANLCPJbxth/vk4mK7Gxfb3bc8HvfTTPbBeh8Hkmux wD11LrlVORZg/z5ff8zXe7Xmld0VdnSpJlxGCvAbKUfYmOXGKRe7P+gJn8nifu0IkmYTvUH7kC/A BOALB/ZQwgU2Aj9jX8Ljbm8Ticd9cs2y5xhy9SNxz2fOJcdhCAXQfyrcf6gFv1DrHs0puK0C7ly2 AVjBtwr4PzWp9noLcIceQDiB40at+kQ/fgpuuRXdYDIOy2LrvA6fg7ivcdVbF4/XJFFtd+I0Qvcc rfcNuOTvFOw/9f33+vHPLv6esavqostm8NiW2FsXc+9u6eL7GVqv9WOnehPsS1mAcwZWeyiL0zDr XrvvGDLS73mfSDweelDiuQEsC47JPZ+oVb7QePvX+foNrPYnTbZhF5doQqcYXHR/0XE+9ItI4M7A fT7WCzhU0DJZzLDjsLx18gR+fziJeNztffviJSstDs0gi8E9t75rX9Ra/6GQv1O4r+CaTGOJvWOL wdFqHbmYzCddsi0+hMyC9/V1Pujn9qR6zjzkjj/G0qUSj4dKUy32xrqCWDqhWPYbDx4VgH9UyM0t /6pwV4qROJus/sL76RF+jzvb8msc6PtWeTaT6mGYUAIte8JDb1k87iGPOR4PlaaeunAmltJU3Boz C34p1ZnhWNTyvf6c00WbAYq1OwZaVXMzZ+5zPXnceFtZIx7Hssix1JdGRuOqt7g0FVtJjaXaGtmO 8k5ic8mjARwOZyDky7qebhNwkWpDx5l77ZuepbUsHh8D5JXMemSuettKU/EgCTaDtN58GG//32uK ObkZ43FRP8MZ388iuFElYCGfs8jGx+Pmql/DuvU3XWSuettKU329OU4usZg7hskr8QIO42tC52qx Y8r3+FLqx75uy6L/qJ/l43FzG6/VslhMHtXR0iWNHbAAKMbS1FB33YV2zrHXH8RiwXNZbIBvawjx aM+585nE3+1jUw8TH4/fAOTeVY9l66yNJ8dw//sWHqIhwKNXP4I/5kwWj98V2w8XejOLvsVWS3Wt l1KG3CepXki1f5tPuMWyddYm9xy3x9A9vwLAozkK2hYLjtsRxR+yKPn7AHDfSLVwBHuf+9bHqTfn w3j8WBabDWy1lDUwyAHDi7adHEP33A8VjLVfe5SA2xPzVv+QH8EtH6s7il1RcVTMsVSbLaQMObrq u/LEUtaGqSpPzUlkgQfSAOAO9V2L6br57bHQZJtWxN+xuejFH+8SXtOtuun2pB+C5SrKWF/pHzqT xWYPXXHVVy1l/f+N67Ymnwp43ZTWzFlvPDVmB0uO4aEd08kxTLD57bHbtrnnWwdcM+n+SJ7oH/ha 3XVzxc3FO9MHwb2URSehQYJdgLyplBVvRusYIwEIHxsq+GmtIeDtNdo5eTxCG2NxC96LuBWJhS2t 2B6LzUXP4Qac6R/SCvwt9sbjpNYmyVx2bLaYdQTyulJWc9cNcAt1pjWWd13Q8QETmtLqz9CP9JoV Z/qt3RYe/Y0te47z6bCYqHXueRSAOyvutygsY45x541+6RDcPkzY9DoCuMXj/mjpHVibmf79rqUc Rv+Uklq0zJjwDLWnxpNjhdf1VsquPNYLPra8iZ906qsFMeQh4I+APJdqmWDPWYM7/fzAxeJnUk4I sTLSLrnqFo/b9o7djDsK/7WUPd/qWkqv+zMHboXOvFv2/Aiu1Ut3rWKx3r489Sbgnrcq/o4GcINc yrG5OHQgg7g819f8VRbH+lqvtq646U3xuLnj1mnmBoDf1FFWm9aCW5UIbE8Wu7fYzsd+RMk1tN51 5amtjL+jAtyDjk9XyP7iCCGD/Iu+bz3G9zpkxX08PoKb0Kz3ayl7t/elWiSUPfJn7YCLvhd4aIQe BjHXLiRVnho14CvE6ZYAuXJW/IVaiUEHrTjG4wf67111hW/Aou/I00bz+tnsuEJn4EPjgWOsPkyq PLV1gAeeslYUY7PCPkm5/YJ9vbpkxXtwPS3+PYDY0dcLPLYhhT//3hTP+4x9jOcHkitPbSXggT1z az7/WQH3ybYuWXEPOTaJzKU6UPGpZ+yzgIVeZbtt2ycAlxmOZMpT22rB7WKE3PSPUhZRHHXUinvg dgI35KYbUzRNaW2TkipPbS3gzor7kb4F5DZFBK14T7olg3i2Iphd1irdW1rrnktLb35vxa0Znp/b 3eoLs0HQ62rGqdJ6J7c91lrAYRsNO15eQCxu++LRNaGnojQWSW6PtdmCN8Xiti5lsXcWRdUBntz2 WKsBD1jxsVT7Vl+6CzQj5FRN/J3k9ljbLTjGTzYcDls9fQU3fSLdjsWpZuud5PZYCoD7J7CNd8Xy 1Wv3FCbklDcQSW6PtR5wcNNzqS9fvWIsTjUYh2S3x1Jx0ZeVr1pGnbE4FbLeyW6PJQG4S7aFyle/ 0IpTSwxDkttjqVhwkebyVVpxqgnwZLfHkgE8sGXmy1c/B6w4xfg76e2xlCx4yIqzfJVaZr2T3h5L CnCWr1JrKvntsdQseFMszvJVyrvnyW+PJQc4y1epNax38ttjKVpwvIAsX6Wa4u/Q9th1au55ioCz fJVaxT3H0USYPU9meyxJwBvKVy8c4LepXUhqbfd8rPeGAZ5c/J2qi+7dsGuNv7/q22+BWIvqjntu yTXbGrsEwJPZHksW8ED5KrpiVwFXjIB3zz23/MyllPvfycXfqVrwkDtms6Zu9ULSetM9v6oBPKl7 IvWOo+aW5XCBk9kCoTbqnieZeE0dcJyl5cf2dGHMMNVh9zx1wG3Kh42w3ZfqNEwcWE/RPU/OPU8S cJ1EihM3C7CLGV1Hug6ku0MR6J53yD1P1YL7IfUF0MXs8GLiyXEAcFpwuudJuufJAQ7WuwfW+xAA PyHgdM+74p6naMEz556P1Gqf6DrSj2EMTtE9T7ZsOVUX3dxzA9zc88KaD6WcPErRPU/WPU8KcOee 22zsQ7XaxzXWmxac7nmy7nlqFhzd8z2Ivw1ub70JN93z5E8VphiDY/a8znrTPe+Oe24Hjgq4/YGj pN3zZAAPuOce8EO16HTPuxt7W+OPy6645ylZcJ89p3vO2Btdc+sHYICPpSNNP1KLwX38fUT3vJNx N/YCKCw39shfaL6ZqnueOuAHCvmBWm+6591yzcdqsQuwz3XZEIzOtM9OFXA7XDICuFm5lj7g2Dbb LPf7+fprvj6om17pyZey9U4tBu9BDD5QsO30GGPv7rjmNtnG4H6ngH9U6DvVG7/1gGsGHS14Xy22 HQvdlfIcON3ztOG2pNpntdh/6nqvH7MhlJ2w3qlY8CxgwT3ghLtbcfc5wG3W+1I62GwzNRcdrbct xt7dgNvi7o/qlhvgHxR63BrLu2C9Uwbc4m9a8PThngTg/kOXd82nXXHNUwQcE2wDcNGxDxuVHtzj GrgL1/xTV11zUz/RGNwn2OiipwN3HnDLLeb+fb5+0/fPpcya30sHilpSBRwhx+6p/QDchLzdVtuy 5T7mLoD+db7+q5AXrrnf8867BnfrAYctMm/Je7LYHplwt98lt60w75b/rnD/qv/udNydkgXPVlhU e8EWcMktmWaHRzDm/k0hfwdxd6cKWlJ30aluuOSXap3PpZpQw2IWhLszBS2pAj5bYVHttdreJS+s M1aoWbb8XGPub4Q7IcCLiwdxOD71cQ4ZZ5G112rfOpf8PcBtVvuTlHPf7wh3mi46JmIsXptKeSQQ IedVj9cLs2t3p1b7Ui3zuVpqq1Cz02Hokt9LB1owdRFwfPLbDXKvayKcA94GsENWG11yg/udWu2P atWtt1qlOwvhTtOC49Pf5oFXXDZa8Ghi7JDHZVb7Sq22ueR/wToHqz2W6qz3nGB3A3BLyowBcrPi 1PaAlkCOBB/INpTgs4P7vVpxO899BVabLnmHAM8d4Nf6Fl24XLg/viqU8sSwZhZww81ioztuLY0v AO4PCva5VHupjUNeGeHuTgw+cTcNTrAoPtf1zi7L4PWW1rvUj3no4paX5UfupDpK6AvAbT3UPgHY flABXfKuAK5bZaEpFpfg0hVP/qIBozVeTDkWny15vwleb21zqe5CrPPz7eum4Iob2GMH9xcF2qC+ 0Gv3rS6XQri75aKLVNv2WLtc7IWNgLf5hFmTFQ5BXOcqe3hnDkpcj4Hcw32j6xrgvpRqz3KbPHId cMdptRmDf++HbcUR1g+7mC56oID34HePsWZ9XYBlCcQPAVc5BK+3uLjV+ADWc9XfAWNthNsAvwqs ccBi02p3HXBw0+2c8LWU1U8F3MXwgyH8vrkstlL2oGc/ENynAIzWtQ7iqQMuBG/u/o9ltyvZ6kfk RCyZNgb33Cz0GOC/rXmgEGxa8AoU2MKnSNaMHNzFzXoi5bQT7PiSyfOcH181efVYgB9qklkGzCQQ CyO8D86C37n1WMD9Vpgt+77+9RFsAr6SFTc3vXDRrS+6uBjdRhrZ5w30Hdn8GfJV4l9piIGXAYxw TAIWeAKrDt5cFgtP8PvP1gTcF7JMHMxT5z3kBJuArxr7Wa8uA1akzLAXsd5LcN33pRxMaBbdXPfe Ey35MnBDSa7HAOzdcA8xWvAQvN5DCNXzz9b4fev2v/OahxvBJuBrWXG7ye2OMatufbMN8GNNvhnk z9HLbbZi8mq2JAZuAhgfANMaiKfu89MA3E2exmNDkmXHeAk2AX80ULeyOAjekm82WtgAt+W7sW4C 8GXJq1wWdwLWBRgt5UMA7Ny5zR7eJig3mVAk0D/S6KX4S+kZceyVbp1WbeqorREk4dCK+4EJT3HR l4GLcOcNMXATwHnN96l1h2sSfHVQrv17E2IC/qMgx26rONYIe6cP3Md3N5Rsq8soh5JXuax2pj1v cKGbIJ4tgZdQEvDWg27dVvuy2F55F97uSHUaylMBny1JXq2yz70qwHUQE2AC3inQ69ose8v92D3x poxyKHm1LAYmwBQBXwN0/Bs0tVzeRJJNZHnyigBTBPwHAB96AGwC8Kb4lwBTBDwS+Nf+NgSXoiiK oiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiK oiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiqa/qfAAMAHXdgUBlpSmoAAAAASUVORK5CYII="
            transform="translate(-7.548 45.906)"
            overflow="visible"
          />
        </g>
      )}
      <ellipse cx={144.3} cy={205.2} rx={81} ry={15.9} fill="#55a32a" />
      <path
        d="M183.9 87.1c-11.1-3.9-21.4-3.5-22.9.8l-1.2 3.5c-.5 1.9.6 4.1 2.9 6.4l-34.2 98 .2.1c.2 3.3 5.8 7.8 13.6 10.5s15 2.7 17.1.2l.2.1 34.2-98c3.2-.3 5.5-1.4 6.3-3.2l1.2-3.5c1.5-4.4-6.3-11-17.4-14.9z"
        opacity={0.69}
        fill="#ddf7fa"
      />
      <path
        d="M165.6 97.9L133 192.8s5 4.8 11.5 7.1 13.4 1.6 13.4 1.6l33.5-94.5c-6.9-.2-20.2-4.6-25.8-9.1z"
        opacity={0.69}
        fill="#ddf7fa"
      />
      <path
        d="M152.7 136.4L133 192.8l.2.1c.4 1.9 5.2 4.8 11.4 7s11.8 2.8 13.3 1.6l.2.1 21.1-60.6-26.5-4.6z"
        fill="#5ae1fe"
      />
      <path
        d="M155.6 137.5l-18.9 54.2h.1c.2 1.7 3.8 4.2 8.5 5.9 4.8 1.7 9.1 1.9 10.4.7h.1l20.1-57.7-20.3-3.1z"
        fill="#20c4fe"
      />
      <ellipse
        transform="rotate(-79.52 165.82 138.566)"
        cx={165.8}
        cy={138.6}
        rx={2.8}
        ry={13.5}
        fill="#99fbfe"
      />
      <ellipse
        transform="rotate(-70.781 181.254 94.601)"
        cx={181.3}
        cy={94.6}
        rx={5.5}
        ry={15.5}
        fill="#ddf7fa"
      />
      <radialGradient
        id="prefix__M"
        cx={302.625}
        cy={1774.51}
        r={3.011}
        gradientTransform="rotate(19.219 5029.68 529.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={156.1}
        cy={148.9}
        r={3}
        opacity={0.52}
        fill="url(#prefix__M)"
      />
      <radialGradient
        id="prefix__N"
        cx={308.495}
        cy={1770.116}
        r={1.948}
        gradientTransform="rotate(19.219 5029.68 529.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={163.1}
        cy={146.7}
        r={1.9}
        opacity={0.52}
        fill="url(#prefix__N)"
      />
      <radialGradient
        id="prefix__O"
        cx={316.265}
        cy={1776.709}
        r={1.948}
        gradientTransform="rotate(19.219 5029.68 529.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={168.3}
        cy={155.5}
        r={1.9}
        opacity={0.52}
        fill="url(#prefix__O)"
      />
      <radialGradient
        id="prefix__P"
        cx={306.547}
        cy={1784.85}
        r={3.027}
        gradientTransform="rotate(19.219 5029.68 529.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={156.4} cy={160} r={3} opacity={0.52} fill="url(#prefix__P)" />
      <radialGradient
        id="prefix__Q"
        cx={313.469}
        cy={1791.29}
        r={2.796}
        gradientTransform="rotate(19.219 5029.68 529.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={160.8}
        cy={168.4}
        r={2.8}
        opacity={0.52}
        fill="url(#prefix__Q)"
      />
      <path
        d="M78.7 148.6l-18.8-37.8c1.5-1.6 2.3-3 2.1-4h.1l-1-2c-1.2-2.5-9-1.1-17.4 3.1-8.4 4.2-14.2 9.6-13 12.1l.8 1.6c.6 1.1 2.4 1.4 5.1 1.1l18.8 37.6c-9.4 9.9-12.5 24-6.7 35.8 7.7 15.5 28 21.1 45.2 12.5 17.2-8.6 25-28.1 17.2-43.6-5.9-11.9-18.9-17.9-32.4-16.4z"
        opacity={0.71}
        fill="#ddf7fa"
      />
      <ellipse
        transform="rotate(-26.492 45.7 111.983)"
        cx={45.7}
        cy={112}
        rx={14.3}
        ry={3.1}
        fill="#ddf7fa"
      />
      <path
        d="M55.7 109.5c2.1-1.7 3.2-3.1 2.8-3.8-.8-1.5-7.1.1-14.2 3.6s-12.2 7.6-11.4 9.1c.4.8 2.2.7 4.8.1M57.4 112.8l20.1 40.4c11.9-1.8 23.6 3.5 28.8 13.8 6.6 13.2.1 29.9-14.5 37.2-14.6 7.3-31.9 2.5-38.5-10.8-5.2-10.4-2.3-22.9 6.3-31.3l-20.2-40.6s3.4-.6 9.4-3.6 8.6-5.1 8.6-5.1z"
        opacity={0.58}
        fill="#ddf7fa"
      />
      <path
        d="M52.6 192.2c4.3-9.4 11.8-6.1 26.4-13.4 14.6-7.3 19.3-8.1 27.3-11.7 6.6 13.2 0 29.7-14.6 37-14.7 7.4-31.7 4.3-39.1-11.9z"
        fill="#fea519"
      />
      <path
        d="M52.6 192.2c1.7 3.4 8.3-5.4 29.6-7 16.3-1.2 25.7-14.8 24-18.2-5.1-.3-8.4 4-30.2 5.8-19.3 1.6-25.1 16-23.4 19.4z"
        fill="#febd19"
      />
      <path
        d="M108.2 172.2c-.4 10.7-7 21.2-18 26.7-13.2 6.6-28.3 5-37.3-6.3 7.5 15.8 24.3 18.8 38.8 11.6 12.8-6.4 19.4-19.9 16.5-32z"
        fill="#febd19"
      />
      <path
        d="M96 160c-4.2-5.1-11.7-5.8-16.8-1.7-5.1 4.2-2.7 9.1 1.5 14.2s8.6 8.4 13.7 4.3c5-4.1 5.8-11.7 1.6-16.8z"
        opacity={0.39}
        fill="#fffffa"
      />
      <ellipse
        transform="rotate(-26.492 60.304 130.139)"
        cx={60.3}
        cy={130.2}
        rx={3.4}
        ry={13.4}
        opacity={0.39}
        fill="#fffffa"
      />
      <path fill="#ffa4d7" d="M160.9 136.9l5.6-8.3 4.2 3.7-4.8 10.2z" />
      <path
        d="M165.7 129.7s.6 2.9 4.2 4.2c1.8-2.9 3.4-6.5 3.4-6.5l-3.8 1.5-.9-3.8-2.9 4.6z"
        fill="#231c86"
      />
      <path
        d="M143.1 157.5s16.9-19.4 21-25.4c7 5.9 9.4 13 9.4 13s-13.7 24-24.9 29.1l-5.5-16.7z"
        fill="#ddf7fa"
      />
      <path
        d="M111.4 186.6c-4.8 12.2-2.7 27.3-.1 29.9 2.1 1 4.3 0 4.3 0s.3-10.8 8.8-18.9c1.6 14.2.8 18.8.8 18.8l2.6 2.2s13.2-12 11.7-25.9c-1.5-13.9-28.1-6.1-28.1-6.1z"
        fill="#ffb6d7"
      />
      <path
        d="M158.1 197.7c0-14.9-7.5-48.2-28.1-46.7-14.9 1.1-29.8 24.8-34.1 41 5.4 8.7 17.7 17.6 32.5 17.6s24.2-3.5 29.7-11.9z"
        fill="#ddf7fa"
      />
      <path
        d="M111.1 216.3l2.4 5.7 1.1-3.4 2.4 2.2-1.2-5.6s-2.7 1.4-4.7 1.1zM129.9 216.3l-2.4 5.7-1.1-3.4-2.4 2.2 1.2-5.6s2.7 1.4 4.7 1.1z"
        fill="#231c86"
      />
      <path
        d="M135.2 161.1s-2 31.8-6.9 48.5h2.9s5.7-23.3 5.6-48.6l-1.6.1z"
        fill="#9fcff9"
      />
      <path
        d="M124.1 158c-6.8-2.8-22.7-22.9-22.7-22.9s1.5 12.3-11.8 15.9c12 15.7 22 21.1 22 21.1l12.5-14.1z"
        fill="#ddf7fa"
      />
      <ellipse
        transform="rotate(-52.649 95.412 143.07)"
        cx={95.4}
        cy={143.1}
        rx={10}
        ry={4}
        fill="#9fcff9"
      />
      <path
        d="M102.2 137.8l-5.6-5.7-3.4 3.7 5.9 8.8c.1.1 3.3-4.5 3.1-6.8z"
        fill="#ffb6d7"
      />
      <circle cx={133.2} cy={165.4} r={1.7} fill="#ffdc07" />
      <circle cx={132.3} cy={173.6} r={1.7} fill="#f10344" />
      <circle cx={131.5} cy={181.9} r={1.7} fill="#ff48cf" />
      <circle cx={130.1} cy={192} r={1.7} fill="#10b3ef" />
      <path
        d="M118.5 167.9l10.1 5.2s-.7 7.9-4.6 8.1c-3.8.2-8-2.6-7.9-5.3.2-1.8 2.4-8 2.4-8z"
        fill="#9fcff9"
      />
      <path fill="#ffa4d7" d="M134.4 132.6l2.1-7.1 7.6 4.4-1.9 4.5z" />
      <path fill="#f73d84" d="M141.8 133l-5.2-.8.7-5.8 5.9 2.9z" />
      <path fill="#ffb6d7" d="M136.5 125.5l8.2 9.1 2.2-6.1z" />
      <path
        d="M148.7 145.6c7.5 8.3-5.4 15.5-14.5 15.5-9.9 0-15.4-7.8-15.4-15.5s7.4-13.9 16.5-13.9 12.9 4.1 13.4 13.9z"
        fill="#ffb6d7"
      />
      <path
        d="M137.2 158.4c-9.9 0-15.4-7.8-15.4-15.5 0-2.9 1.1-5.6 2.9-7.9-3.6 2.5-5.8 6.3-5.8 10.6 0 7.7 5.5 15.5 15.4 15.5 5.5 0 12.3-2.6 15.3-6.5-3.5 2.3-8.3 3.8-12.4 3.8z"
        fill="#ffa4d7"
      />
      <path fill="#ffa4d7" d="M124.1 135.8l-6.7-3.1-1.6 8.6 4.6 1.5z" />
      <path fill="#80390a" d="M146.5 228.2v1.1l1.2.4 10.8-6.7v-.6z" />
      <path fill="#ab460a" d="M146.5 228.2l10.5-6 1.5.2-10.6 6.3z" />
      <path fill="#80390a" d="M159.9 228.6v1.1l-1.2.4-10.7-6.7v-.6z" />
      <path fill="#ab460a" d="M159.9 228.6l-10.5-6-1.4.2 10.6 6.3z" />
      <path
        d="M136.1 214.3c-1.3 1.3-1.3 3.3-2.2 4.7-.9 1.4-3.3 1.1-2.1 2.5s2.7 1 4.3-.5 1.5-4.9 3.5-5.1c2-.3-3.5-1.6-3.5-1.6z"
        fill="#4d1c9f"
      />
      <path
        d="M139.2 215.2c-.1 0-.2.1-.4.1-2 .3-1.9 3.7-3.5 5.1-1.2 1.1-2.3 1.6-3.3 1.2 1.2 1.2 2.6.7 4.1-.6 1.6-1.4 1.5-4.9 3.5-5.1.8-.2.4-.5-.4-.7z"
        fill="#330a8a"
      />
      <ellipse cx={153.5} cy={202.1} rx={25} ry={20.4} fill="#4d1c9f" />
      <path
        d="M171.9 214.9c1.3 1.3 1.3 3.3 2.2 4.7.9 1.4 3.3 1.1 2.1 2.5s-2.7 1-4.3-.5c-1.6-1.4-1.5-4.9-3.5-5.1-2-.3 3.5-1.6 3.5-1.6z"
        fill="#4d1c9f"
      />
      <path
        d="M160.2 182.5c4.8 3.7 7.8 8.9 7.8 14.7 0 11.3-11.2 20.4-25 20.4-2.3 0-4.5-.3-6.7-.7 4.5 3.5 10.6 5.6 17.3 5.6 13.8 0 25-9.1 25-20.4 0-9.3-7.8-17.2-18.4-19.6z"
        fill="#330a8a"
      />
      <ellipse cx={153.8} cy={184.5} rx={22} ry={7.9} fill="#330a8a" />
      <path
        fill="#330a8a"
        d="M131.8 182.1v2.5h1.1zM175.7 184.5v-2.4l-1.4 2.8z"
      />
      <path
        d="M175.7 182.1c0 2.5-3.4 4.8-8.6 6.2-.2 0-.5-.3-.6-.2-.2 0-.2.5-.3.5-3.5.9-7.8 1.4-12.4 1.4-4 0-7.8-.4-11-1.1-.3-.1-.6-.5-.8-.6-.4-.1-.7.2-1.1.1-5.5-1.4-9.1-3.8-9.1-6.4 0-2.9 4.3-5.4 10.8-6.8.2 0 .4.2.6.2.3-.1.4-.4.7-.4 3-.5 6.4-.8 9.9-.8 8.4 0 15.8 1.7 19.4 4.2.2.1.1.5.3.6.2.1.5 0 .7.1 1 1 1.5 2 1.5 3z"
        fill="#4d1c9f"
      />
      <ellipse cx={153.8} cy={181.8} rx={17.7} ry={5.2} fill="#7ae00e" />
      <path
        d="M172.4 221c-1.6-1.4-1.5-4.9-3.5-5.1h-.1c-.8.3-1.2.6-.4.7 2 .3 1.9 3.7 3.5 5.1 1.6 1.4 3.1 1.9 4.3.5.1-.1.2-.3.3-.4-1.2 1-2.5.5-4.1-.8zM154.4 206.1l1.8 4.1-4.7 4.1.9 4.4h1.5l-1.8-4.4 4.5-4z"
        fill="#330a8a"
      />
      <path
        d="M159.5 186.7c.5.2 2.2 2.4 2.4 2.7.3.4.1 2.3.1 2.3l-1.5.2s.6.5.8 2.3c.3 1.8-.7 7.9.7 8.2 1.4.3.1-4.8 0-6.7s.3-4.1.4-4.1c.6-.1 2.1-.4 2.4-.4.3-.4-.2-2.3-.2-2.3s-.1-2.7.5-3.6c-4.8.2-5.6 1.4-5.6 1.4zM154.8 187c.9 0 1 2.3 1.8 2.1s-.5-1.9.3-2.2c-1.8-1-2.1.1-2.1.1z"
        fill="#7ae00e"
      />
      <path
        d="M148.4 182.6c-5.4.4-7.3-1.3-1.4-3 3.2-.9 4-2 3.9-2.9-8.4.4-14.9 2.5-14.9 5.1 0 2 3.8 3.7 9.5 4.6.9-.6 1.7-1.3 2.6-1.8 3.3-1.7 11.9.7 15.6-1.3 3.8-2.1-9.9-1.2-15.3-.7z"
        fill="#f153cd"
      />
      <path
        d="M153.8 178.2c8.9 0 16.3 1.9 17.5 4.4.1-.3.2-.5.2-.8 0-2.9-7.9-5.2-17.7-5.2s-17.7 2.3-17.7 5.2c0 .3.1.5.2.8 1.2-2.5 8.6-4.4 17.5-4.4z"
        fill="#330a8a"
      />
      <radialGradient
        id="prefix__R"
        cx={143.241}
        cy={183.6}
        r={1.47}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={143.2} cy={183.6} r={1.5} fill="url(#prefix__R)" />
      <radialGradient
        id="prefix__S"
        cx={149.189}
        cy={181.114}
        r={1.978}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={149.2} cy={181.1} r={2} fill="url(#prefix__S)" />
      <radialGradient
        id="prefix__T"
        cx={154.559}
        cy={184.908}
        r={1.47}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={154.6} cy={184.9} r={1.5} fill="url(#prefix__T)" />
      <radialGradient
        id="prefix__U"
        cx={161.955}
        cy={181.542}
        r={1.94}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={162} cy={181.5} r={1.9} fill="url(#prefix__U)" />
      <radialGradient
        id="prefix__V"
        cx={165.122}
        cy={183.091}
        r={0.714}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={165.1} cy={183.1} r={0.7} fill="url(#prefix__V)" />
      <radialGradient
        id="prefix__W"
        cx={152.502}
        cy={181.114}
        r={0.714}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={152.5} cy={181.1} r={0.7} fill="url(#prefix__W)" />
      <radialGradient
        id="prefix__X"
        cx={139.928}
        cy={182.13}
        r={0.922}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={139.9} cy={182.1} r={0.9} fill="url(#prefix__X)" />
      <radialGradient
        id="prefix__Y"
        cx={157.832}
        cy={184.419}
        r={0.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={157.8} cy={184.4} r={0.7} fill="url(#prefix__Y)" />
      <radialGradient
        id="prefix__Z"
        cx={157.832}
        cy={179.602}
        r={0.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle cx={157.8} cy={179.6} r={0.7} fill="url(#prefix__Z)" />
      <path
        d="M150.3 225.8c-2-1.2-3.4-6.5 3.4-11 .1 3.9 5.2 6 3.9 9.1-1.2 3-5.2 3.1-7.3 1.9z"
        fill="#ff801b"
      />
      <path
        d="M151.8 226.1c1.4-.8-3-6.8-2.3-8.4-1.6 1.3-2.5 3.5-1.8 5.4.8 2.3 3.7 3.3 4.1 3z"
        fill="#ff801b"
      />
      <path
        d="M146.2 204.5c-1 4.6-3 8-7.1 7.1s-6.6-5.3-5.6-9.9 5.1-7.5 9.2-6.6c4.1.9 4.5 4.9 3.5 9.4z"
        opacity={0.45}
        fill="#ff801b"
      />
      <ellipse
        cx={152.5}
        cy={219.4}
        rx={7.6}
        ry={6.6}
        opacity={0.45}
        fill="#ff801b"
      />
      <path
        d="M138.1 190s10.7 3.7 22.4 2c-15.1 5.2-22.4-2-22.4-2z"
        opacity={0.45}
        fill="#ff801b"
      />
      <path
        d="M154.1 226c-1.7.8-3.2 0-3.5-1.9-.5-3.2 2.1-5.3 2.1-5.3s.3 3.1.8 3.6c-.1-.9-.2-1.9-.2-1.9s4.1 3.9.8 5.5z"
        fill="#fff"
      />
      <path fill="#f73d84" d="M119.6 141.7l2.8-4.5-4.9-3.3-1.6 6.3z" />
      <radialGradient
        id="prefix__aa"
        cx={67.503}
        cy={194.962}
        r={4.384}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={67.5}
        cy={195}
        r={4.4}
        opacity={0.52}
        fill="url(#prefix__aa)"
      />
      <radialGradient
        id="prefix__ab"
        cx={81.978}
        cy={195.915}
        r={2.308}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={82}
        cy={195.9}
        r={2.3}
        opacity={0.52}
        fill="url(#prefix__ab)"
      />
      <radialGradient
        id="prefix__ac"
        cx={89.538}
        cy={189.105}
        r={3.779}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={89.5}
        cy={189.1}
        r={3.8}
        opacity={0.52}
        fill="url(#prefix__ac)"
      />
      <radialGradient
        id="prefix__ad"
        cx={76.271}
        cy={203.125}
        r={2.875}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <circle
        cx={76.3}
        cy={203.1}
        r={2.9}
        opacity={0.52}
        fill="url(#prefix__ad)"
      />
      <circle cx={131.8} cy={144.7} r={6.9} fill="#231c65" />
      <circle cx={146.8} cy={140.8} r={6.9} fill="#231c65" />
      <circle cx={147.3} cy={140.8} r={6.9} fill="#231c86" />
      <circle cx={132.3} cy={144.3} r={6.9} fill="#231c86" />
      <path fill="#231c86" d="M126.5 143.8h-8.8l-2.5 4.2 2 .7 1.7-2.5h8z" />
      <path fill="#ffb6d7" d="M117.4 132.7l1.5 12.2-6-2.4z" />
      <path
        d="M137.4 141.5s1.2-2.1 3.5-1.7c.6.7.4 1.4.4 1.4s-3.1.7-3.5 1.8c-.6-.7-.4-1.5-.4-1.5z"
        fill="#231c86"
      />
      <circle cx={132.3} cy={144.3} r={6} fill="#ddf7fa" />
      <circle cx={147.3} cy={140.8} r={6} fill="#ddf7fa" />
      <path
        d="M133.6 149.4c-3.3 0-6-2.7-6-6 0-1.7.8-3.3 1.9-4.4-1.9 1-3.3 3-3.3 5.3 0 3.3 2.7 6 6 6 1.6 0 3-.6 4-1.6-.7.5-1.6.7-2.6.7zM148.2 145.8c-3.3 0-6-2.7-6-6 0-1.3.4-2.4 1.1-3.4-1.2 1.1-2 2.7-2 4.4 0 3.3 2.7 6 6 6 2 0 3.8-1 4.9-2.6-1 1-2.4 1.6-4 1.6z"
        fill="#9fcff9"
      />
      <circle cx={147.3} cy={141.4} r={3.7} fill="#231c86" />
      <circle cx={133.8} cy={145.1} r={3.7} fill="#231c86" />
      <ellipse
        transform="rotate(-16.544 141.473 150.298)"
        cx={141.4}
        cy={150.3}
        rx={8}
        ry={4.9}
        fill="#f73d84"
      />
      <path
        d="M144.5 153.4c-4.2 1.3-8.3.2-9.1-2.4-.4-1.2.1-2.5 1-3.7-2.1 1.5-3.2 3.5-2.7 5.2.8 2.6 4.8 3.7 9.1 2.4 2.3-.7 4.2-1.9 5.3-3.3-1 .8-2.2 1.4-3.6 1.8z"
        fill="#e62084"
      />
      <circle cx={145.3} cy={149.1} r={1.8} fill="#e62084" />
      <circle cx={139.6} cy={150.5} r={1.8} fill="#e62084" />
      <circle cx={132.3} cy={143.2} r={1.5} fill="#ddf7fa" />
      <circle cx={131} cy={146.5} r={0.9} fill="#ddf7fa" />
      <circle cx={145.6} cy={139.4} r={1.5} fill="#ddf7fa" />
      <circle cx={144.3} cy={142.8} r={0.9} fill="#ddf7fa" />
      <g>
        <path
          d="M83.8 145.6l-17.9-11.8c-1-.6-1.2-1.9-.6-2.9l17.6-26.8c.6-1 1.9-1.2 2.9-.6l17.9 11.8c1 .6 1.2 1.9.6 2.9L86.7 145c-.6 1-1.9 1.3-2.9.6z"
          fill="#ff8605"
        />
        <path
          fill="#bcd2fa"
          d="M85.277 104.643l17.644 11.574-16.894 25.755-17.644-11.574z"
        />
        <path
          d="M80.6 140.4c-5.6-3.1-13.7-10.1-16.7-13.9 8.8-2.9 21.4-21.8 21.4-21.8l17.6 11.6c0-.1-14 22.5-22.3 24.1z"
          fill="#ddf7fa"
        />
        <path
          d="M98.5 116l-10.7-7c-.4-.3-.5-.8-.2-1.2l1.8-2.8c.3-.4.8-.5 1.2-.2l10.7 7c.4.3.5.8.2 1.2l-1.8 2.8c-.2.3-.8.4-1.2.2z"
          fill="#0b6080"
        />
        <path
          d="M97.7 110.8l-4.9-3.2c-.5-.3-.6-.9-.3-1.4l1-1.5c.3-.5.9-.6 1.4-.3l4.9 3.2c.5.3.6.9.3 1.4l-1 1.5c-.3.5-1 .6-1.4.3z"
          fill="#0b6080"
        />
      </g>
      <path
        d="M98.5 133.9l-4.9-4.9 1.1 4.4-3.6-.8 3.7 5.4c0 .1 3.3-1.3 3.7-4.1z"
        fill="#231c86"
      />
      <g fill="#fff">
        <path d="M95.2 248c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.3v-.4-.3-.7c0-.3.1-.5.1-.7 0-.1.1-.2.1-.3s.2-.1.3-.1h.3c.1 0 .2 0 .3.1.2 0 .4.1.6.1h.9c.3 0 .7 0 1-.1.3 0 .7-.1.9-.2s.5-.2.7-.4c.2-.1.3-.3.3-.5s-.2-.3-.5-.4c-.3-.1-.8-.2-1.3-.3-.5-.1-1.1-.2-1.7-.4-.6-.1-1.2-.4-1.7-.6-.5-.3-.9-.6-1.3-1.1s-.5-1-.5-1.8c0-.7.2-1.4.6-1.9.4-.5.9-1 1.5-1.3.6-.3 1.3-.6 2.1-.8.8-.2 1.6-.2 2.4-.2h.6c.2 0 .4 0 .6.1l.1-.4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1.7 0 1.3.1 1.9.3.2.1.3.2.4.3.1.1.1.2.1.3 0 .4 0 .8-.1 1.2 0 .4-.1.7-.1 1 0 .3-.1.6-.1.9 0 .3-.1.6-.1.9 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2h-.9c-.2 0-.5-.1-.8-.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.3-.1-.4v-.4-.4c-.2 0-.5-.1-.7-.1h-.7c-.4 0-.7 0-1.1.1s-.6.1-.8.2l-.6.3c-.1.1-.2.3-.2.4 0 .2.2.4.5.5.3.1.7.2 1.2.3s1 .2 1.6.4c.6.1 1.1.3 1.6.6s.9.6 1.2 1.1c.3.5.5 1.1.5 1.8s-.2 1.3-.5 1.8-.7 1-1.3 1.4-1.2.7-1.9.8-1.5.3-2.4.3c-.4-.2-1.1-.3-1.9-.4zM110.1 239.1c.3 0 .6 0 .9.1.3 0 .6.1.9.2.3.1.5.2.6.4.1.1.2.4.2.7 0 .2 0 .4.1.5v.5c0 .4 0 .9-.1 1.3 0 .3-.1.4-.2.5-.1.1-.3.1-.5.1-.4 0-.7 0-1-.1-.4-.1-.7-.4-.8-.8 0-.2 0-.3-.1-.5v-.5c-.3 0-.6.1-.9.2s-.5.3-.8.5c-.2.2-.4.4-.5.7s-.2.5-.2.8c0 .3 0 .5.1.8.1.3.2.5.4.7.2.2.4.3.7.5.3.1.5.2.9.2.2 0 .3 0 .5-.1s.4-.1.5-.1c.2-.1.3-.1.5-.2s.3-.1.4-.2c.1-.1.2-.1.3-.2s.2-.1.2-.1c.2 0 .3.1.4.3.1.1.1.3.2.4.1.1.1.3.2.5 0 .1.1.2.1.3v.2c0 .2-.1.3-.3.5-.2.2-.4.3-.6.4s-.5.2-.8.3c-.3.1-.6.2-.9.2-.3.1-.6.1-.9.1-.8 0-1.4-.1-2-.2-.5-.2-1-.4-1.4-.6-.4-.3-.7-.6-.9-.9-.2-.3-.4-.7-.5-1l-.3-.9c-.1-.3-.1-.6-.1-.8 0-.7.2-1.3.5-1.9.3-.6.7-1.1 1.2-1.5.5-.4 1.1-.7 1.8-1 .8-.2 1.5-.3 2.2-.3zM116.2 235c.3 0 .6 0 .9.1.2 0 .4.1.6.3.1.1.3.3.3.6.1.2.1.6.1 1 0 .2 0 .4-.1.6-.1.2-.1.4-.3.5-.1.1-.3.3-.6.3-.2.1-.6.1-.9.1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.3s-.2-.3-.3-.5-.1-.5-.1-.9c0-.6.1-1 .4-1.3.2-.3.7-.4 1.3-.4zm-1.5 5.4c0-.3 0-.5.1-.7.1-.2.2-.3.4-.3s.4-.1.7-.1H117.3c.2 0 .3.1.3.2s.1.3.1.6v3.6c0 1.1-.1 2.3-.2 3.5v.5c0 .2-.1.2-.1.3-.1.1-.2.1-.3.2-.1 0-.3.1-.5.1-.3 0-.7 0-1-.1-.4 0-.6-.1-.7-.3s-.2-.4-.2-.7c0-.4 0-.9-.1-1.3v-1.3-2c0-.8.1-1.5.1-2.2zM127.6 243.8c-.3.1-.7.2-1.1.3s-.9.2-1.4.3-1 .1-1.5.2-1 .1-1.5.1c.2.3.5.5.9.7s.8.2 1.2.2c.3 0 .7 0 1.1-.1.4-.1.8-.2 1.2-.4.2-.1.3-.1.4-.1.1 0 .2 0 .2.1s.1.2.1.3c0 .1.1.3.1.4 0 .1.1.3.1.4v.4c0 .2-.1.4-.3.6-.4.3-.9.6-1.5.8-.7.2-1.4.3-2.2.3-.6 0-1.2-.1-1.7-.3-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-1-1.4-.3-.6-.4-1.2-.4-1.9s.1-1.3.4-1.9c.3-.6.6-1.1 1-1.5.4-.4.9-.7 1.5-1 .6-.2 1.2-.3 1.8-.3.8 0 1.5.2 2.1.5s1 .7 1.4 1.1c.3.4.6.9.7 1.3.1.5.2.9.2 1.2 0 .1 0 .3-.1.4 0 0-.1.1-.3.2zm-3.9-2.3c-.4 0-.8.1-1.2.4s-.6.6-.7 1c.5 0 1.1-.1 1.7-.1.6 0 1.2-.1 1.7-.3-.1-.3-.3-.6-.6-.7-.3-.2-.6-.3-.9-.3zM129 240.3c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1h1.1c.2 0 .3 0 .4.1.1.1.1.2.1.3v.5c.4-.3.9-.5 1.4-.7s1-.2 1.5-.2c.3 0 .5 0 .9.1l.9.3c.3.2.5.4.7.8.2.3.3.8.3 1.4v1.1c0 .4 0 .9-.1 1.4 0 .5-.1 1-.1 1.6s-.1 1.1-.2 1.6c0 .2-.1.4-.2.6-.1.2-.3.3-.6.3h-.7c-.3 0-.6-.1-.8-.1-.4-.1-.6-.3-.6-.8v-.5c0-.2 0-.5.1-.8 0-.3.1-.8.1-1.3v-1.9c0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.5-.3-.3 0-.6.1-1 .2-.3.1-.7.3-1 .5 0 .8 0 1.5.1 2.3 0 .8.1 1.5.2 2.3v.4c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.3-.1-.1-.2-.4-.2-.6-.1-.9-.2-1.8-.2-2.8s-.1-1.9-.1-2.8v-.6-.8zM144.3 239.1c.3 0 .6 0 .9.1.3 0 .6.1.9.2.3.1.5.2.6.4.1.1.2.4.2.7 0 .2 0 .4.1.5v.5c0 .4 0 .9-.1 1.3 0 .3-.1.4-.2.5-.1.1-.3.1-.5.1-.4 0-.7 0-1-.1-.4-.1-.7-.4-.8-.8 0-.2 0-.3-.1-.5v-.5c-.3 0-.6.1-.9.2s-.5.3-.8.5c-.2.2-.4.4-.5.7s-.2.5-.2.8c0 .3 0 .5.1.8.1.3.2.5.4.7.2.2.4.3.7.5.3.1.5.2.9.2.2 0 .3 0 .5-.1s.4-.1.5-.1c.2-.1.3-.1.5-.2s.3-.1.4-.2c.1-.1.2-.1.3-.2s.2-.1.2-.1c.2 0 .3.1.4.3.1.1.1.3.2.4.1.1.1.3.2.5 0 .1.1.2.1.3v.2c0 .2-.1.3-.3.5-.2.2-.4.3-.6.4s-.5.2-.8.3c-.3.1-.6.2-.9.2-.3.1-.6.1-.9.1-.8 0-1.4-.1-2-.2-.5-.2-1-.4-1.4-.6-.4-.3-.7-.6-.9-.9-.2-.3-.4-.7-.5-1l-.3-.9c-.1-.3-.1-.6-.1-.8 0-.7.2-1.3.5-1.9.3-.6.7-1.1 1.2-1.5.5-.4 1.1-.7 1.8-1 .8-.2 1.5-.3 2.2-.3zM156.9 243.8c-.3.1-.7.2-1.1.3s-.9.2-1.4.3-1 .1-1.5.2-1 .1-1.5.1c.2.3.5.5.9.7s.8.2 1.2.2c.3 0 .7 0 1.1-.1.4-.1.8-.2 1.2-.4.2-.1.3-.1.4-.1.1 0 .2 0 .2.1s.1.2.1.3c0 .1.1.3.1.4 0 .1.1.3.1.4v.4c0 .2-.1.4-.3.6-.4.3-.9.6-1.5.8-.7.2-1.4.3-2.2.3-.6 0-1.2-.1-1.7-.3-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-1-1.4-.3-.6-.4-1.2-.4-1.9s.1-1.3.4-1.9c.3-.6.6-1.1 1-1.5.4-.4.9-.7 1.5-1 .6-.2 1.2-.3 1.8-.3.8 0 1.5.2 2.1.5s1 .7 1.4 1.1c.3.4.6.9.7 1.3.1.5.2.9.2 1.2 0 .1 0 .3-.1.4 0 0-.1.1-.3.2zm-3.9-2.3c-.4 0-.8.1-1.2.4s-.6.6-.7 1c.5 0 1.1-.1 1.7-.1.6 0 1.2-.1 1.7-.3-.1-.3-.3-.6-.6-.7-.4-.2-.7-.3-.9-.3z" />
      </g>
      <Checkmarks
        visited={visited}
        process={process}
        position={{ x: 130, y: 140 }}
        gradientIdChunk="science"
      />
    </g>
  );
};

export default Science;
